/**
 * Standard Span Type values for "IkeCalc" PLA forms (not IPF)
 */
export enum SpanType {
	NextPole = 'NEXT_POLE',
	PreviousPole = 'PREVIOUS_POLE',
	Other = 'OTHER_POLE',
	Building = 'BUILDING',
}

export const SPAN_TYPES = [
	{
		type: SpanType.NextPole,
		name: 'Fore Span',
	},
	{
		type: SpanType.PreviousPole,
		name: 'Back Span',
	},
	{
		type: SpanType.Other,
		name: 'Other',
	},
	{
		type: SpanType.Building,
		name: 'Building',
	},
] as const;
